import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=7664fdb2&scoped=true&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreen.vue?vue&type=style&index=0&id=7664fdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7664fdb2",
  null
  
)

export default component.exports